import { lazy } from "react"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { LuftProgressContextProvider } from "./context/LuftProgressContext";
import ParkPanorama from "./pages/ParkPanorama";
import { PflanzenBProgressContextProvider } from "./context/pflanzenBProgressContext";
import { PflanzenAProgressContextProvider } from "./context/pflanzenAProgressContext";
import { WasserAProgressContextProvider } from "./context/WasserAProgressContext";
import { WasserBProgressContextProvider } from "./context/WasserBProgressContext";
import Rootlayout from "./layouts/Rootlayout";
const LandingPage = lazy(() => import("./pages/LandingPage"));

const AirLuft = lazy(() => import("./pages/AirLuft"));
const WasserA = lazy(() => import("./pages/WasserA"));
const WasserB = lazy(() => import("./pages/WasserB"));
const PlfanzenA = lazy(() => import("./pages/PlfanzenA"));
const PlfanzenB = lazy(() => import("./pages/PlfanzenB"));




const router = createBrowserRouter([
  {
    path: '/',
    element: <Rootlayout />,
    children: [
      {
        path: '/',
        element: <LandingPage />
      },

      {
        path: '/parkPanorama',
        element: <ParkPanorama />
      },
      {
        path: '/wasserA',
        element: <WasserA />
      },
      {
        path: '/wasserB',
        element: <WasserB />
      },
      {
        path: '/pflanzenA',
        element: <PlfanzenA />
      },
      {
        path: '/pflanzenB',
        element: <PlfanzenB />
      },
      {
        path: '/air-luft',
        element: <AirLuft />
      },
    ]
  }
]
  , {
    basename: '/360-Lernwelt'
  })


export default function App() {



  return (
    <LuftProgressContextProvider>
      <PflanzenBProgressContextProvider>
        <PflanzenAProgressContextProvider>
          <WasserAProgressContextProvider>
            <WasserBProgressContextProvider>
              <RouterProvider router={router} />
            </WasserBProgressContextProvider>
          </WasserAProgressContextProvider>
        </PflanzenAProgressContextProvider>
      </PflanzenBProgressContextProvider>
    </LuftProgressContextProvider>
  )
}